/**
 * Session flag: user confirmed the vehicle is safe and legal to drive before entering the claim funnel.
 * Cleared when starting a new claim from the claims hub or dashboard.
 */

const STORAGE_KEY = 'club4x4_claim_legal_to_drive_confirmed'

/** Record safe-to-drive confirmation for the active claim session (scoped by policy ref). */
export function markLegalToDriveConfirmed(policyRef: string | null): void {
  sessionStorage.setItem(STORAGE_KEY, policyRef ?? '')
}

/** True when the user has already answered Yes on the safe-to-drive gate this session. */
export function isLegalToDriveConfirmed(policyRef: string | null): boolean {
  return sessionStorage.getItem(STORAGE_KEY) === (policyRef ?? '')
}

/** Drop the gate so the next claim start shows the safe-to-drive modal again. */
export function clearLegalToDriveConfirmed(): void {
  sessionStorage.removeItem(STORAGE_KEY)
}
